import { api } from "./api";

// Brand meta (logos, hostnames, terms URLs) — fetched once per session
let _promise = null;
export function getBrand() {
  if (!_promise) {
    _promise = api.get("/meta/brand").then((r) => r.data).catch(() => ({}));
  }
  return _promise;
}

export const HEROES = {
  dwh: "/assets/hero-dwh",
  dwt: "/assets/hero-dwt",
  neutral: "/assets/hero-neutral",
};
export const FOOTER_IMAGE = "/assets/footer";
export const LOVE_IN_FULL_LOGO = "/assets/logo-love-in-full.png";

// <picture> block: optimised WebP (800w + full) with JPG fallback.
export function HeroPicture({ base, className = "", testId = "" }) {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${base}-800.webp 800w, ${base}.webp 1920w`}
        sizes="100vw"
      />
      <source
        type="image/jpeg"
        srcSet={`${base}-800.jpg 800w, ${base}.jpg 1920w`}
        sizes="100vw"
      />
      <img
        src={`${base}.jpg`}
        alt=""
        className={className}
        data-testid={testId || undefined}
      />
    </picture>
  );
}

export const PUB_SITES = {
  dwh: "https://www.dancingwithher.com",
  dwt: "https://www.dancingwiththem.com",
};
export const LOVE_IN_FULL_SITE = "https://www.loveinfull.co";

// Resolve a publication from the current hostname.
// First checks Settings-configured hostnames, then falls back to the known
// production subdomains so the right brand loads even before Settings are set.
// Returns "dwh" | "dwt" | null.
export function pubFromHostname(brand) {
  const host = window.location.hostname.toLowerCase();
  if (brand.dwt_hostname && host === brand.dwt_hostname.toLowerCase()) return "dwt";
  if (brand.dwh_hostname && host === brand.dwh_hostname.toLowerCase()) return "dwh";
  if (host === "submit.dancingwiththem.com") return "dwt";
  if (host === "submit.dancingwithher.com") return "dwh";
  return null;
}
